<template>
  <div id="addpaying" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="catalogo"
    >
      <v-row no-gutters class="titulo catalogoTitle"
        >Catálogo de Sucursal</v-row
      >

      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-3"
          >¿La estructura organizacional será por?</v-col
        >
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select name="estructura" id="estructura" v-model="estructura">
            <option disabled value="0">Selecciona estructura</option>
            <option
              v-for="carga in structure"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-3" v-if="estructura == 2"
          >Empresa Pagadora</v-col
        >
        <v-col cols="12" sm="4" class="py-3 selectGris" v-if="estructura == 2">
          <select name="pagadora" id="pagadora" v-model="enterprise">
            <option disabled value="0">Selecciona</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-3">¿El tipo de carga?</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select name="location" id="location" v-model="carga">
            <option disabled value="0">Selecciona carga</option>
            <option
              v-for="carga in cargas"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-1" v-if="carga == 2">
          <p style="font-size: 18px">
            <i style="color: #0f6c21" class="fas fa-file-excel"></i>
            <a href="#" @click="descargaExcel()">&nbsp;&nbsp;Descargar</a>
            plantilla de excel para llenar.
          </p>
        </v-col>

        <v-col cols="12" sm="12" class="uploadfile py-2" v-if="carga == 2">
          Subir archivo de Excel con la lista de sucursales a registrar.
          <input
            type="file"
            id="archivo"
            lang="es"
            ref="fileUploadPerfilEdit"
            @click="resetFile"
            @change="previewFiles($event)"
          />
        </v-col>
        <v-col cols="12" sm="12" class="mt-3 pa-0" align-self="end">
          <button class="boton" @click="validacionCatalogo()">Siguiente</button>
          <router-link to="/branchs" id="nuevaSucursal">
            <button class="boton">Regresar</button>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo">Alta Sucursal</v-row>
      <!-- verificar la empresa comercial -->
      <v-row no-gutters class="datos">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="mt-11 mb-2"
        >
          <div class="form-group inputEnterprise">
            <label for="rs" style="width: 10% !important; margin-left: -0.1%"
              >Empresa Pagadora</label
            >
            <select name="suburb" id="suburb" v-model="enterprise">
              <option disabled value="0">Seleccione empresa</option>
              <option
                v-for="enterprise in enterprises"
                :key="enterprise.id"
                v-bind:value="enterprise.id"
              >
                {{ enterprise.razonSocial }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="name">Nombre</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="name"
              required
              maxlength="200"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="telefono">Telefóno</label>
            <input
              type="text"
              name="telefono"
              id="telefono"
              placeholder="55 10 20 30 40"
              autocomplete="false"
              v-model="telefono"
              minlength="10"
              maxlength="10"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-5"
          >Domicilio</v-col
        >

        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="pais">País</label>
            <input
              type="text"
              name="pais"
              id="pais"
              v-model="country"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="cp">C.P.</label>
            <input
              type="text"
              name="cp"
              id="cp"
              maxlength="5"
              placeholder="Obligatorio"
              required
              autocomplete="false"
              v-model="cp"
              @keypress="isNumber($event)"
              @change="consultaDireccion()"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="estado">Estado</label>
            <input
              type="text"
              name="estado"
              id="estado"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              maxlength="35"
              v-model="state"
              readonly
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="municipio">Municipio</label>
            <input
              type="text"
              name="municipio"
              id="municipio"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              v-model="municipality"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="colonia">Colonia</label>

            <select name="suburb" id="suburb" v-model="suburb">
              <option disabled value="0">Selecciona Colonia</option>
              <option
                v-for="suburb in suburbs"
                :key="suburb.id"
                v-bind:value="suburb.id"
              >
                {{ suburb.name }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group inputEnterprise">
            <label for="calle" style="margin-left: 1%; width: 10%">Calle</label>
            <input
              type="text"
              name="calle"
              id="calle"
              v-model="street"
              maxlength="35"
              required
              autocomplete="false"
              placeholder="Obligatorio"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="ne">N° Exterior</label>
            <input
              type="text"
              name="ne"
              id="ne"
              placeholder="Obligatorio"
              autocomplete="false"
              required
              v-model="exterior"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="ni">N° Interior</label>
            <input
              type="text"
              name="ni"
              id="ni"
              placeholder="Obligatorio"
              v-model="interior"
              autocomplete="false"
              required
              maxlength="20"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="mt-11">
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!--Error-->
    <v-dialog v-model="error" width="450">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">Sucursal</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            ¿Esta seguro de almacenar la sucursal?
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" text @click="aux()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Sucursal</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      catalogo: true,
      show: false,
      estructura: 0,
      structure: [
        {
          id: 1,
          nombre: "Empresa Comercial",
        },
        {
          id: 2,
          nombre: "Empresa Pagadora",
        },
      ],
      carga: 0,
      cargas: [
        {
          id: 1,
          nombre: "Manual",
        },
        {
          id: 2,
          nombre: "Automatica",
        },
      ],
      nombreArchivo: "",
      selectedFile: "",
      stepn: "3-N",
      error: false,
      errors: [],
      respuesta: "",
      dialog: false,
      confirmation: false,
      advice: false,
      country: "México",
      state: "",
      cp: "",
      exterior: "",
      interior: "",
      municipality: "",
      suburb: 0,
      street: "",
      address: [],
      suburbs: [],
      telefono: "",
      name: "",
      enterprise: 0,
      enterprises: [],
      activa: false,
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    onFileChange(evt) {
      const file = evt.target.files[0];
      this.url = URL.createObjectURL(file);
      var fileBase = evt.target.files[0];
      var reader = new FileReader();
      reader.onloadend = function () {
        console.log("RESULT", reader.result);
        sessionStorage.setItem("base64img", reader.result);
      };
      reader.readAsDataURL(fileBase);
    },
    previewFiles(event) {
      this.errors = [];
      console.log(event);
      this.nombreArchivo = event.target.files[0].name;
      this.nombreArchivo.toLowerCase();
      var regex = new RegExp("(.*?).(xlsx|xls)$");

      if (!regex.test(this.nombreArchivo)) {
        this.nombreArchivo = "";
        this.titulo = "Archivo inválido";
        this.errors.push(
          "No se permite el archivo que ingreso favor de ingresar archivo con layout predeterminado."
        );
        this.error = true;
      } else {
        this.selectedFile = event.target.files[0];
      }
    },
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 ]+$"); // Letras y números
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode > 31 && charCode < 48) || charCode > 57) {
        evt.preventDefault();
      } else return true;
    },
    validaImss() {
      var imss = this.imss;
      if (imss.length != 11) {
        this.errors.push("Número de IMSS incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(imss.length);
        return false;
      }
    },
    validaRfc() {
      var strCorrecta;
      strCorrecta = this.rfc;
      if (this.rfc.length == 12) {
        var valid = "^(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      } else {
        var valid =
          "^(([A-Z]|[a-z]|s){1})(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      }
      var validRfc = new RegExp(valid);
      var matchArray = strCorrecta.match(validRfc);
      if (matchArray == null) {
        this.errors.push("El RFC es incorrecto favor de verificarlo.");
        return false;
      } else {
        console.log("Correcto");
        return true;
      }
    },
    validaCp() {
      console.log(this.cp);
      var cp = this.cp;
      if (cp.length != 5) {
        this.errors.push("Código Postal incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(cp.length);
        return false;
      }
    },
    validacion() {
      this.errors = [];
      if (this.enterprise == 0) {
        this.errors.push("Se debe especificar la Empresa Pagadora.");
      }

      if (this.name == "" || this.name == " ") {
        this.errors.push("Se debe especificar el nombre de la Sucursal.");
      }
      if (this.telefono.length < 10 || this.telefono == "0000000000") {
        this.errors.push("Se debe especificar telefono de la sucursal.");
      }
      if (this.country == "" || this.country == " ") {
        this.errors.push("Se debe especificar el país.");
      }
      this.validaCp();
      if (this.state == "" || this.state == " ") {
        this.errors.push("Se debe especificar el estado.");
      }
      if (this.municipality == "" || this.municipality == " ") {
        this.errors.push("Se debe especificar el municipio.");
      }
      if (this.suburb == "" || this.suburb == 0) {
        this.errors.push("Se debe especificar la colonia.");
      }
      if (this.street == "" || this.street == " ") {
        this.errors.push("Se debe especificar la calle.");
      }
      if (this.country == "" || this.country == " ") {
        this.errors.push("Se debe especificar el país.");
      }
      if (this.state == "" || this.state == " ") {
        this.errors.push("Se debe especificar el estado.");
      }
      if (this.exterior == "" || this.exterior == " ") {
        this.errors.push("Se debe especificar el número exterior.");
      }
      if (this.interior == "" || this.interior == " ") {
        this.errors.push("Se debe especificar el número interior.");
      }
      if (this.errors.length == 0) {
        return (this.advice = true);
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    resetFile() {
      this.$refs.fileUploadPerfilEdit.value = "";
    },

    procesarExcel: function () {
      var data = new FormData();
      data.append("idEmpresa", this.enterprise);
      data.append("excel", this.selectedFile, this.selectedFile.name);
      console.log("Data");
      console.log(data);
      this.show = true;
      axios
        .post(Server + "/sucursales/cargar/excel", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.show = false;
          if (response.status == 200) {
            this.respuesta = "Archivo procesado con éxito";
            this.confirmation = true;
          } else {
            this.respuesta = "Por favor verifica los datos ingresados.";
            this.error = true;
          }
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    descargaExcel() {
      this.show = true;
      ////console.log("Producto id");
      ////console.log(localStorage.productoId);
      axios(
        {
          url: Server + "/sucursales/plantilla",
          method: "GET",
          responseType: "blob",
        },
        { useCredentails: true }
      ) // CORS
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var fecha = new Date();
          link.setAttribute(
            "download",
            "Sucursales" + fecha.getTime() + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
          this.show = false;
        })
        .catch((e) => {
          this.show = false;
        });
    },
    validacionCatalogo() {
      this.errors = [];
      if (this.estructura == 0 || this.carga == 0) {
        this.errors.push(
          "Debe especificar la estructura organizacional y/o el tipo de carga"
        );
      }
      if (this.estructura == 2) {
        if (this.enterprise == 0 || this.enterprise == null)
          this.errors.push("Debe especificar la empresa pagadora.");
      }
      if (this.estructura == 2 && this.carga == 2) {
        if (!this.selectedFile)
          this.errors.push("Debes ingresar un archivo válido.");
      }
      if (this.errors.length == 0) {
        // Asignar empresa comercial
        if (this.estructura == 1)
          this.enterprise = localStorage.idCommercialEnterprise;

        // --
        if (this.carga == 2) {
          this.procesarExcel();
        } else {
          this.catalogo = false;
        }
      } else {
        this.titulo = "Catálogo de sucursales";
        this.error = true;
      }
    },
    regresar() {
      this.enterprise = 0;
      this.telefono = 0;
      this.activa = false;
      this.name = "";
      this.pais = "";
      this.cp = "";
      this.estado = "";
      this.municipio = "";
      this.localidad = "";
      this.colonia = "";
      this.calle = "";
      this.exterior = "";
      this.interior = "";
      this.$router.push("/branchs");
    },
    consultaDireccion() {
      if (this.cp.length == 5) {
        this.suburbs = [];
        this.show = true;
        axios
          .get(Server + "/direcciones/" + this.cp)
          .then((response) => {
            console.log(response);
            this.address = response.data;
            this.state = this.address[0].estado;
            this.municipality = this.address[0].municipio;
            this.address.forEach((value, index) => {
              this.suburbs.push({
                id: value.asentamientoId,
                name: value.colonia,
              });
            });
            this.show = false;
          })
          .catch((e) => {
            console.log(response);
            this.show = false;
          });
      } else {
        console.log("Menor a 5");
      }
    },
    aux() {
      this.confirmation = false;
      this.enterprise = 0;
      this.telefono = "";
      this.name = "";
      this.activa = false;
      this.country = "";
      this.cp = "";
      this.state = "";
      this.municipality = "";
      this.suburb = "";
      this.exterior = "";
      this.interior = "";
      this.street = "";
      this.$router.push("/branchs");
    },
    guardar() {
      this.advice = false;
      this.show = true;
      axios
        .post(Server + "/sucursales", {
          EmpresaId: this.enterprise,
          NombreSucursal: this.name,
          Telefono: parseInt(this.telefono),
          Pais: this.country,
          CodigoPostal: this.cp,
          AsentamientoId: this.suburb,
          NumeroExterior: this.exterior,
          NumeroInterior: this.interior,
          Calle: this.street,
          Activo: true,
        })
        .then((response) => {
          console.log(response);
          this.show = false;
          this.name = "";
          this.telefono = "";
          this.country = "";
          this.cp = "";
          this.state = "";
          this.municipality = "";
          this.suburb = "";
          this.exterior = "";
          this.interior = "";
          this.street = "";
          this.enterprise = 0;
          this.respuesta = "La Sucursal fue guardada con éxito";
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.name = "";
          this.phone = "";
          this.country = "";
          this.cp = "";
          this.state = "";
          this.municipality = "";
          this.suburb = "";
          this.exterior = "";
          this.interior = "";
          this.street = "";
          this.enterprise = 0;
          this.respuesta = "La Sucursal no fue almacenada";
          this.confirmation = true;
        });
    },
    cancel() {
      this.enterprise = 0;
      this.telefono = "";
      this.activa = false;
      this.name = "";
      this.country = "";
      this.cp = "";
      this.state = "";
      this.municipality = "";
      this.suburb = "";
      this.exterior = "";
      this.interior = "";
      this.street = "";
      this.$router.push("/branchs");
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          //console.log(response);
          this.enterprises = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
  },
  created() {
    this.nombre();
    this.listar();
  },
};
</script>
